import { css } from 'lit';

export const styles = css `
  :host {
    display: block;
    height: 100vh;
  }

  .container {
    background-color: var(--u-modal-drawer-bg-color, var(--u-color-surface-container-low, rgb(247, 242, 250)));
    color: var(--u-drawer-text-color, var(--u-color-on-secondary-container, rgb(29, 25, 43)));
    height: 100%;
    overflow: auto;
    padding: var(--u-drawer-padding, var(--u-drawer-padding-block, 16px) var(--u-drawer-padding-inline, 28px));
  }

  @media (min-width: 1200px) {
    .container {
      background-color: var(--u-standard-drawer-bg-color, var(--u-color-body, var(--u-color-surface, rgb(254, 247, 255))));
    }
  }
`;
